import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { modals } from 'ducks';
import FontAwesome from 'utils/FA';
import registeredComponent from 'utils/registeredComponent';

const RefundComponentButton = ({ dispatch, orderId, className }) => {
  const onClick = () => {
    dispatch(modals.actions.show('RefundForm', { orderId }));
  };

  return (
    // This is dumb, but the bootstrap dropdown this component gets used in expects an <a> anchor tag.
    <a className={className} style={{ cursor: 'pointer' }} onClick={onClick}>
      Issue Refund
      <FontAwesome name='exchange' preNbsp />
    </a>
  );
};

RefundComponentButton.propTypes = {
  dispatch: PropTypes.func.isRequired,
  orderId: PropTypes.string.isRequired,
  className: PropTypes.string
};

RefundComponentButton.defaultProps = {
  className: ''
};

export default registeredComponent('RefundComponentButton')(connect()(RefundComponentButton));
